import { getAccessToken as getToken } from '@drifthq/web-auth'
import { isFirstUser } from '../org/selectors'

export const getRoot = state => state.user
export const getPassword = state => getRoot(state).password
export const getName = state => getRoot(state).name
export const getEmail = state => getRoot(state).email
export const getCompanyName = state => getRoot(state).companyName
export const getFlow = state => getRoot(state).flow
export const getUserId = state => getRoot(state).userId
export const getUniqueEmail = state => getRoot(state).uniqueEmail
export const getDisabledEmail = state => getRoot(state).disabledEmail
export const getResetToken = state => getRoot(state).resetToken
export const getProfilePicture = state => getRoot(state).profilePicture
export const getAvatarUrl = state => getRoot(state).avatarUrl
export const getAccessToken = state => getRoot(state).accessToken || getToken()
export const isSSOProvisionedFlow = state => getRoot(state).SSOProvisionedFlow
export const ssoRedirectError = state => getRoot(state).SSORedirectError
export const emailIsSSOEnabled = state => getRoot(state).emailIsSSOEnabled
export const checkEmailIsSSOEnabledPending = state => getRoot(state).checkEmailIsSSOEnabledStatus === 'pending' || emailIsSSOEnabled(state)
export const getUserJwt = state => getRoot(state).userJwt
export const getValidEmail = state => getRoot(state).validEmail
export const hasAssociatedDomain = state => getRoot(state).domainFound
export const isPopupHidden = state => getRoot(state).hidePopup
export const findMyTeamVerificationEmailStatus = state => getRoot(state).findMyTeamVerificationEmailStatus

export const isCalendarSeatOnboarding = state => getRoot(state).isCalendarSeatOnboarding
export const isRepInvitedFlow = state => (getResetToken(state) || !isFirstUser(state)) && !isCalendarSeatOnboarding(state)
export const passwordUpdateStatus = state => getRoot(state).passwordUpdateStatus
export const passwordConfig = state => getRoot(state).passwordConfig
export const passwordConfigFetched = state => getRoot(state).passwordConfigFetched
export const redeemedRelayStateSuccess = state => getRoot(state).redeemedRelayStateSuccess



// WEBPACK FOOTER //
// ./src/modules/user/selectors.js